<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ shipment.reference }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <ion-list>
                <ion-item v-if="shipmentLines.length < 1">No items on list yet</ion-item>
                <ion-item v-for="line in shipmentLines" :key="line.id" button detail @click="edit(line)">
                    <ion-avatar slot="start" v-if="line.item.id">
                        <single-item-image :item="line.item" />
                    </ion-avatar>
                    <ion-label class="ion-margin-start">
                        <h2>{{ line.item.name }}</h2>
                        <h3>{{ line.qty_required }} x {{ line.item.item_number }} @ {{ line.location.code }}</h3>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
        <ion-footer>
            <ion-button expand="block" size="large" @click="add">Add Item</ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {modalController} from '@ionic/vue';
import {
    IonContent, IonPage, IonLabel, IonItem, IonHeader, IonToolbar,
    IonTitle, IonButtons, IonIcon, IonList, IonFooter, IonButton,
    IonAvatar
} from '@ionic/vue';

import {closeOutline, checkmarkCircleOutline} from 'ionicons/icons';
import PullDownRefresh from "@/components/PullDownRefresh";
import AddItemModal from "@/views/modules/lists/pages/AddItemModal";
import SingleItemImage from "@/components/SingleItemImage";
import LocationSorter from "@/services/LocationSorter";

export default {
    inject: ['$http', '$toast', '$validationAlert'],
    name: 'EditShipmentModal',
    components: {
        SingleItemImage,
        PullDownRefresh,
        IonContent, IonPage, IonLabel, IonItem, IonHeader, IonToolbar,
        IonTitle, IonButtons, IonButton, IonIcon, IonList, IonFooter,
        IonAvatar
    },
    props: {
        shipmentId: Number
    },
    computed: {
        shipmentLines() {
            if (this.shipment && this.shipment.lines) {
                return LocationSorter.sortByLocationCodes(this.shipment.lines);
            }
            return [];
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        /**
         *
         * @param event
         */
        async refresh(event = null) {
            this.$http.get(`/api/shipments/${this.shipmentId}`, {params: {
                    include: 'lines,lines.item,lines.item.skus,lines.sku,lines.location,lines.item.locations,lines.item.locations.pivot,lines.location.zone'
                }}).then(response => {
                this.shipment = response.data;
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        },

        edit(line) {
            return modalController.create({
                component: AddItemModal,
                componentProps: {
                    shipment: this.shipment,
                    line: line
                }
            }).then(m => {
                m.present();
                m.onDidDismiss().then(() => {
                    this.refresh();
                });
            })
        },

        add() {
            return modalController.create({
                component: AddItemModal,
                componentProps: {
                    shipment: this.shipment
                }
            }).then(m => {
                m.present();
                m.onDidDismiss().then(() => {
                    this.refresh();
                });
            })
        },
        close() {
            modalController.dismiss({
                refresh: true
            });
        }
    },
    data() {
        return {
            shipment: {}
        }
    },
    setup() {
        return {
            closeOutline, checkmarkCircleOutline
        };
    }
}
</script>
